__turbopack_context__.v({
  "className": "dm_sans_2c3ee5-module__Cz3ZMW__className",
  "variable": "dm_sans_2c3ee5-module__Cz3ZMW__variable",
});
